import React from 'react';

const LoadingState = ({ message = "Loading..." }) => {
  return (
    <main>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <div className="app-loader mb-4">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <p className="text-secondary">{message}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoadingState;